<script lang="ts">
    import dayjs from 'dayjs'
    import _isToday from 'dayjs/plugin/isToday'
    dayjs.extend(_isToday)
    import { onMount } from 'svelte'
    import { EventSourcesRepository } from '../../../modules/eventsApi/event-sources/event-sources.repository'
    import { EventSourcesService } from '../../../modules/eventsApi/event-sources/event-sources.service'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import type { EventSource } from '../../../modules/eventsApi/event-sources/event-source.entity'
    import ChannelsLogPerson from './channels-log-person.svelte'
    import type { Channel } from '../../../modules/brokerApi/channels/channel'
    import { ChannelsRepository } from '../../../modules/brokerApi/channels/channels.repository'
    import { ChannelsService } from '../../../modules/brokerApi/channels/channels.service'
    import { ChannelType } from '../../../modules/brokerApi/channels/channels.enum'

    const esRep: EventSourcesRepository = new EventSourcesRepository()
    const esS: EventSourcesService = new EventSourcesService(esRep)

    let contacts: EventSource[] = []
    let personId: string = null

    const channelsRep: ChannelsRepository = new ChannelsRepository()
    const channelsS: ChannelsService = new ChannelsService(channelsRep)

    let channels: Channel[] = []

    let show = false
    let eventSources: EventSource[] = []
    let channelId: string = null
    let query = ''
    let sources: string = 'whatsapp'

    let d = new Date()
    d.setHours(0, 0, 0, 0)
    let date = dayjs(new Date()).format('YYYY-MM-DD')

    async function loadChannels() {
        channels = await channelsS.getAll({ type: ChannelType.wa_user })
        if (channels.length > 0) channelId = channels[0].channelId
    }

    async function loadLogs(channelId) {
        contacts = []
        if (!channelId) {
            return
        }
        show = true
        try {
            return
            let from = new Date(date)
            from.setHours(0)
            from.setMinutes(0)
            from.setSeconds(0)
            let to = new Date(date)
            to.setDate(to.getDate() + 1)
            eventSources = await esS.getAll({ from, to, query, sources, channelId })
            console.log('eventSources', eventSources)
            for (const es of eventSources) {
                if (!contacts.find((el) => el.person.personId === es.person.personId)) {
                    contacts.push(es)
                }
            }
            contacts = contacts
        } catch (error) {
        } finally {
            show = false
        }
    }

    onMount(async () => {
        await loadChannels()
    })

    $: {
        loadLogs(channelId)
    }

    function dateChanged() {
        loadLogs(channelId)
    }

    function setContact(id: string) {
        personId = id
        eventSources = eventSources
    }

    function contactDate(contact: EventSource) {
        if (dayjs(contact.externalDate).isToday()) {
            return dayjs(contact.externalDate).format('HH:mm')
        } else {
            return dayjs(contact.externalDate).format('DD/MM/YY HH:mm')
        }
    }
</script>

<div class="grid-act">
    <div class="date input-group">
        <label for="" class="input-group-text">Transporte</label>
        <select class="form-select" bind:value={channelId}>
            {#each channels as channel}
                <option value={channel.channelId}>{channel.label}</option>
            {/each}
        </select>
    </div>

    <div class="date input-group">
        <label for="" class="input-group-text">Data em que ocorreu uma conversa</label>
        <input type="date" class="form-control" bind:value={date} on:change={dateChanged} />
    </div>
</div>
<LoadSpinner {show} />

<div class="chat-container">
    <div class="contacts scroll-dark">
        {#each contacts as contact}
            <div class="button" class:selected={contact.person.personId === personId} on:click={() => setContact(contact.person.personId)}>
                <div class="name nowrap">
                    {contact.person.name}
                </div>
                <div class="date">{contactDate(contact)}</div>
            </div>
        {/each}
    </div>
    <div class="chat_content">
        <ChannelsLogPerson {personId} startDate={new Date(date)} />
    </div>
</div>

<style>
    .grid-act .date {
        max-width: 450px;
    }
    .chat-container {
        margin-top: 16px;
        display: flex;
        height: 100%;
        overflow: hidden;
        border-radius: 4px;
    }
    .contacts {
        flex: 0 0 300px;
        overflow-y: auto;
        background-color: #2b2b2b;
    }
    .contacts > .button {
        color: #ddd;
        background: #2b2b2b;
        padding: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .contacts .button .name {
        flex-grow: 1;
    }
    .contacts .button .date {
        font-size: 12px;
        flex-wrap: nowrap;
        white-space: nowrap;
        padding-left: 4px;
    }
    .contacts > .button:hover {
        color: white;
        background: #3b3b3b;
    }
    .contacts .selected {
        background: #3b3b3b;
    }
    .chat_content {
        flex: 1 1 auto;
        overflow: hidden;
    }
</style>
